export default __webpack_public_path__ + "static/The_LoomisDifference_Homepage.mp4";